import { useContext } from 'react';

// auth provider
import CustomContext from '../contexts/CustomContext';

// ==============================|| HOOKS - AUTH ||============================== //

const useCustomContext = () => {
  const context = useContext(CustomContext);

  if (!context) throw new Error('context must be use inside provider');

  return context;
};

export default useCustomContext;
